function fn_layout_main() {
    setTimeout(function () {
        fn_nl_preload();
    }, 300);

    //Update product
    $(document).on("click", ".number-count-icon", function () {

        var $parent = $(this).parent(".number-count-field");
        var $input = $parent.find("input");
        var value = $input.val();
        if ($(this).hasClass("plus")) {
            if (value < 99999) {
                value++;
            }
        }
        if ($(this).hasClass("minus")) {
            if (value > 0)
                value--;
        }
        $input.val(value);


        try {
            var product = $input.data('update-product');
            var data = {
                action: 'update-product',
                product: product,
                count: value,
            }

            $.ajax({
                url: ajaxLng + '/ajax/basket/',
                data: data,
                type: 'post',
                dataType: "json",
                success: function (response) {
                    if(response.productCountTotal == 0) {
                        $('.item-total-price-' + product).closest('.cart-item').fadeOut('slow');
                        $('.item-total-price-' + product).closest('.elm_item').fadeOut('slow');                        
                    } else {
                        updateBasketTopInfo(response.totalPrice, response.itemsCount);
                        updateBasketItemPrice(product, response.productPriceTotal, response.productCountTotal);
                    }                    
                }
            });
        } catch (err) {
        }

    });

    $(document).on('submit', 'form.ajax', function (e) {
        e.preventDefault();
        var $frm = $(this);
        $.ajax({
            method: $frm.attr('method'),
            url: $frm.attr('action'),
            data: $frm.serialize()
        });
    });

    $(document).on('change', '#cat-select', function (e) {
        e.preventDefault();
        var $url = $(this).val();
        window.location.replace($url);
    });

    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
        $("html").addClass("ie11");
    }


    function part_sidebar_filter() {
        if ($(window).width() < 960) {
            $(".part_sidebar-filter .togglebox").children("input").each(function () {
                $(this).prop('checked', false);
            });
        }
    }
    part_sidebar_filter();
    $(window).resize(part_sidebar_filter);

}